import { IGatsbyImageData } from 'gatsby-plugin-image'

export type Ratio = {
  x: number
  y: number
}

type ImageWithFocalPoint =
  | {
      focalPoint: {
        focalPoint: {
          x: number | null
          y: number | null
        } | null
      } | null
      image: {
        gatsbyImageData: IGatsbyImageData | null
        file: {
          details: {
            image: {
              height: number | null
              width: number | null
            } | null
          } | null
        } | null
      } | null
    }
  | null
  | undefined

const GetFocalRatio = (
  imageWithFocalPoint: ImageWithFocalPoint,
): Ratio | null => {
  if (
    !imageWithFocalPoint ||
    imageWithFocalPoint?.focalPoint === null ||
    imageWithFocalPoint?.focalPoint.focalPoint === null ||
    imageWithFocalPoint?.focalPoint?.focalPoint?.x === null ||
    imageWithFocalPoint?.focalPoint?.focalPoint?.y === null ||
    imageWithFocalPoint?.image === null ||
    imageWithFocalPoint?.image.file === null ||
    imageWithFocalPoint?.image?.file?.details?.image?.width === null ||
    imageWithFocalPoint?.image?.file?.details?.image?.height === null
  ) {
    return null
  }

  return {
    x:
      (imageWithFocalPoint.focalPoint.focalPoint.x /
        imageWithFocalPoint?.image?.file?.details?.image?.width) *
      100,
    y:
      (imageWithFocalPoint.focalPoint.focalPoint.y /
        imageWithFocalPoint?.image?.file?.details?.image?.height) *
      100,
  }
}

export default GetFocalRatio
